module.exports = __webpack_public_path__ + "static/st1-4-a8418eae767fec70a35833d7fff84709.jpg";